import { render, staticRenderFns } from "./WechatCopy.vue?vue&type=template&id=b86e9de4&scoped=true&"
import script from "./WechatCopy.vue?vue&type=script&lang=js&"
export * from "./WechatCopy.vue?vue&type=script&lang=js&"
import style0 from "./WechatCopy.vue?vue&type=style&index=0&id=b86e9de4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86e9de4",
  null
  
)

export default component.exports